import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { ClientLogoStripComponent } from '../../../shared/components/client-logo-strip/client-logo-strip.component';

@Component({
    selector: 'app-hero-section',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatCardModule, RouterModule, ClientLogoStripComponent],
    templateUrl: './hero-section.component.html',
    styleUrl: './hero-section.component.scss'
})
export class HeroSectionComponent implements OnInit, OnDestroy {
  rotatingWords = ['members', 'payments', 'events', 'content'];
  currentWordIndex = 0;
  currentWord = this.rotatingWords[0];
  private intervalId: any;

  constructor(@Inject(PLATFORM_ID) private readonly platformId: Object) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.intervalId = setInterval(() => {
        this.currentWordIndex = (this.currentWordIndex + 1) % this.rotatingWords.length;
        this.currentWord = this.rotatingWords[this.currentWordIndex];
      }, 2000);
    }
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
